import { Component } from '@angular/core';

import { NavigationLayoutTopMenuBaseComponent } from './navigation-layout-top-menu-base.component';

/**
 * @stable
 */
@Component({
    selector: 'lh-navigation-layout-top-menu-v2',
    templateUrl: 'navigation-layout-top-menu-v2.html',
})
export class NavigationLayoutTopMenuV2Component extends NavigationLayoutTopMenuBaseComponent {}
